import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { CustomFieldsModule } from '@freelancer/custom-fields';
import { DatastoreCustomFieldRelationshipsModule } from '@freelancer/datastore/collections';
import { UiModule } from '@freelancer/ui';
import { DeloitteBillingDetailsComponent } from './deloitte-billing-details.component';
import { DeloitteProjectBillingCodeInputComponent } from './project-billing-code-input/deloitte-project-billing-code-input.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CustomFieldsModule,
    DatastoreCustomFieldRelationshipsModule,
    UiModule,
  ],
  exports: [
    DeloitteBillingDetailsComponent,
    DeloitteProjectBillingCodeInputComponent,
  ],
  declarations: [
    DeloitteBillingDetailsComponent,
    DeloitteProjectBillingCodeInputComponent,
  ],
})
export class DeloitteBillingDetailsModule {}
